<template>
  <div class="card">
    <div class="card-body pb-0">
      <div class="row">
        <div class="col-md-6">
          <div class="form-group">
            <label class="control-label">Region</label>
            <multiselect
              v-model="regionSelected"
              :options="regionOptions"
              track-by="value"
              label="text"
              name="region"
              key="region"
              placeholder
              :disabled="placementIsFinalised"
              data-vv-validate-on="input|blur"
              :class="[errorClass('region'), validClass('region')]"
              :searchable="false"
              :show-labels="false"
            />
          </div><!-- /.form-group -->
        </div>

        <div class="col-12">
          <div class="form-group">
            <label class="control-label">Placement Email Address</label>
            <input v-model="stateEmail" :disabled="placementIsFinalised" v-validate="'email'" name="email" type="email" class="form-control">

            <help-block field="email"/>
          </div><!-- /.form-group -->
        </div>
      </div><!-- /.row -->
    </div>

    <div class="card-footer text-right" v-if="placementIsNotFinalised">
      <ladda-button :click="handleSavePlacement" class="btn btn-sm btn-success">Save Changes</ladda-button>
    </div>
  </div><!-- /.card -->
</template>

<script>
import { placementComputed, placementMethods, graduateComputed } from 'vx/helpers'
import { stateMapper, helpers } from 'mixins/placements'
import { handleServerErrors } from 'utils'
import { pick } from 'lodash'
import Multiselect from 'vue-multiselect'

export default {
  mixins: [stateMapper, helpers],

  components: {
    Multiselect
  },

  data () {
    return {
      regionOptions: [
        {
          value: 'Greater Metropolitan Sydney',
          text: 'Greater Metropolitan Sydney'
        },
        {
          value: 'NSW Central Tablelands',
          text: 'NSW Central Tablelands'
        },
        {
          value: 'NSW Hunter',
          text: 'NSW Hunter'
        },
        {
          value: 'New England',
          text: 'New England'
        },
        {
          value: 'NSW North Coast',
          text: 'NSW North Coast'
        }
      ]
    }
  },

  computed: {
    ...placementComputed,
    ...graduateComputed,

    /**
     * Get and set the selected region
     */
    regionSelected: {
      get () {
        return this.regionOptions.find(option => option.value === this.placement.region)
      },

      set (option) {
        this.stateRegion = option.value
      }
    }
  },

  methods: {
    ...placementMethods,

    async handleSavePlacement () {
      let payload = pick(this.placement, [
        'region',
        'email'
      ])

      try {
        await this.updatePlacement({ graduate: this.graduate, placement: this.placement, payload })
        this.$noty.success('Placement details saved.')
      } catch (error) {
        handleServerErrors(error, this.$validator)
      }
    }
  }
}
</script>
